module.exports = __webpack_public_path__ + "img/big_1_22.3442b65a.png";